// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================
   DESIGN TOKENS
====================================== */
:root {
  --brand:          #1565C0;
  --brand-mid:      #1976D2;
  --brand-light:    #42A5F5;
  --brand-soft:     #E8F1FB;
  --brand-glow:     rgba(21, 101, 192, 0.18);
  --brand-glow-md:  rgba(21, 101, 192, 0.30);
  --surface:        #ffffff;
  --surface-2:      #F5F7FA;
  --page-bg:        #F0F2F5;
  --border:         #DCE8F8;
  --border-strong:  #BBCFF5;
  --text-primary:   #0C1A2E;
  --text-secondary: #334D6E;
  --text-muted:     #7090B0;
  --font:           'Plus Jakarta Sans', sans-serif;
  --ease:           cubic-bezier(0.16, 1, 0.3, 1);
  --radius-sm:      8px;
  --radius-md:      14px;
  --radius-lg:      20px;
  --radius-xl:      24px;
  --shadow-sm:      0 1px 4px rgba(0,0,0,0.06), 0 4px 12px rgba(21,101,192,0.06);
  --shadow-md:      0 4px 20px rgba(0,0,0,0.08), 0 12px 36px rgba(21,101,192,0.10);
  --shadow-avatar:  0 4px 18px rgba(0,0,0,0.18);
  --gpu-accelerate: translateZ(0);
}

* { box-sizing: border-box; margin: 0; padding: 0; }

body {
  font-family: var(--font);
  background-color: var(--page-bg);
}

/* ======================================
   PAGE WRAPPER
====================================== */
.store-page-wrapper {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 80px 16px 40px; /* top padding for fixed Header */
  font-family: var(--font);
}

/* ======================================
   PROFILE CARD
====================================== */
.store-profile-card {
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  position: relative;
  will-change: transform;
  transform: var(--gpu-accelerate);
  /* Top accent line */
  --accent-h: 4px;
}

.store-profile-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: var(--accent-h);
  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, #00BCD4 100%);
  z-index: 2;
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
}

/* ======================================
   BANNER
====================================== */
.store-banner {
  height: 200px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #C8D8ED;
  position: relative;
}

/* Gradient overlay always on so text is readable if banner is bright */
.store-banner::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent 50%, rgba(12,26,46,0.18) 100%);
}

.store-banner-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #1565C0 0%, #42A5F5 50%, #00BCD4 100%);
  opacity: 0.85;
}

/* ======================================
   PROFILE BODY
====================================== */
.store-profile-body {
  padding: 0 20px 20px;
}

/* ── Avatar + follow row ── */
.store-avatar-row {
  display: flex;
  align-items: flex-end;
  margin-top: -44px; /* pull avatar up over banner */
  margin-bottom: 10px;
  position: relative;
  z-index: 3;
}

.store-avatar-wrap {
  flex-shrink: 0;
}

.store-avatar {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid var(--surface);
  box-shadow: var(--shadow-avatar);
  display: block;
  background: var(--surface-2);
  will-change: transform;
  transform: var(--gpu-accelerate);
  image-rendering: -webkit-optimize-contrast;
}

/* ── Follow button ── */
.store-follow-btn {
  padding: 9px 22px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: #fff;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 2px 10px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease), background 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
}

.store-follow-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 18px var(--brand-glow-md);
}

.store-follow-btn.following {
  background: var(--surface-2);
  color: var(--brand);
  border: 1.5px solid var(--brand);
  box-shadow: none;
}

.store-follow-btn.following:hover {
  background: var(--brand-soft);
  transform: translateY(-1px);
}

/* ── Name + description ── */
/* Name + follow on same row */
.store-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}

.store-name-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
}

.store-name {
  font-size: 22px;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.4px;
  line-height: 1.2;
}

.store-desc {
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text-muted);
  line-height: 1.55;
}

/* ======================================
   NAVIGATION TABS
====================================== */
.store-tabs {
  display: flex;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  background: var(--surface);
}

.store-tab-btn {
  flex: 1 1;
  padding: 14px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 600;
  color: var(--text-muted);
  border-bottom: 2.5px solid transparent;
  transition: color 0.18s, border-color 0.18s, background 0.18s;
  letter-spacing: 0.1px;
}

.store-tab-btn:hover {
  color: var(--brand);
  background: var(--brand-soft);
}

.store-tab-btn.active {
  color: var(--brand);
  border-bottom-color: var(--brand);
  font-weight: 700;
  background: transparent;
}

/* ======================================
   TAB CONTENT
====================================== */
.store-tab-content {
  padding: 4px 0 0;
}

/* ======================================
   LOADING SKELETONS
====================================== */
.store-banner-skeleton {
  height: 200px;
  background: linear-gradient(90deg, #e0eaf6 25%, #f0f4fb 50%, #e0eaf6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
}

.store-avatar-skeleton {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: linear-gradient(90deg, #e0eaf6 25%, #f0f4fb 50%, #e0eaf6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  margin-top: -44px;
  border: 4px solid var(--surface);
}

.store-skeleton-line {
  height: 14px;
  border-radius: 7px;
  background: linear-gradient(90deg, #e0eaf6 25%, #f0f4fb 50%, #e0eaf6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  margin-top: 12px;
}

.store-skeleton-line.wide  { width: 55%; }
.store-skeleton-line.narrow{ width: 35%; }

@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ======================================
   RESPONSIVE
====================================== */
@media (min-width: 769px) {
  .store-page-wrapper {
    padding-top: 100px;
  }

  .store-banner {
    height: 240px;
  }

  .store-avatar {
    width: 110px;
    height: 110px;
  }

  .store-avatar-row {
    margin-top: -55px;
  }

  .store-name {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .store-page-wrapper {
    padding: 72px 0 24px;
  }

  .store-profile-card {
    border-radius: 0;
    border-left: none;
    border-right: none;
  }

  .store-banner {
    height: 160px;
  }

  .store-profile-body {
    padding: 0 14px 16px;
  }

  .store-avatar {
    width: 76px;
    height: 76px;
  }

  .store-avatar-row {
    margin-top: -38px;
  }

  .store-follow-btn {
    padding: 8px 18px;
    font-size: 12.5px;
  }

  .store-name {
    font-size: 19px;
  }

  .store-desc {
    font-size: 13px;
  }

  .store-tab-btn {
    font-size: 13px;
    padding: 12px 8px;
  }
}

@media (max-width: 360px) {
  .store-banner { height: 140px; }
  .store-avatar { width: 68px; height: 68px; }
  .store-avatar-row { margin-top: -34px; }
  .store-name { font-size: 17px; }
}

/* ======================================
   KEPT — old classes used by child pages
   (About, Posts, EditPosts, etc.)
====================================== */
.profile_container,
.app-container,
.store_container,
.store-rec-pro-div { /* legacy wrappers — now passthrough */ }

.follow-btn {
  padding: 9px 22px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 2px 10px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
}

.follow-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 18px var(--brand-glow-md);
}

.navigation-tabs {
  display: flex;
  background-color: var(--surface);
  border-bottom: 1px solid var(--border);
}

.navigation-tabs button {
  padding: 13px 20px;
  flex: 1 1;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 600;
  color: var(--text-muted);
  border-bottom: 2.5px solid transparent;
  transition: color 0.18s, border-color 0.18s, background 0.18s;
}

.navigation-tabs button.active-tab {
  border-bottom: 2.5px solid var(--brand);
  color: var(--brand);
  font-weight: 700;
}

.navigation-tabs button:hover {
  color: var(--brand);
  background-color: var(--brand-soft);
}`, "",{"version":3,"sources":["webpack://./src/components/Store.css"],"names":[],"mappings":"AAEA;;wCAEwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;EACjD,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,8EAA8E;EAC9E,gFAAgF;EAChF,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA,IAAI,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAEnD;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB,EAAE,iCAAiC;EAC1D,wBAAwB;AAC1B;;AAEA;;wCAEwC;AACxC;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,uBAAuB;EACvB,yFAAyF;EACzF,UAAU;EACV,oDAAoD;AACtD;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iFAAiF;AACnF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0EAA0E;EAC1E,aAAa;AACf;;AAEA;;wCAEwC;AACxC;EACE,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB,EAAE,+BAA+B;EAClD,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,gCAAgC;EAChC,cAAc;EACd,4BAA4B;EAC5B,sBAAsB;EACtB,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,2EAA2E;EAC3E,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,oFAAoF;EACpF,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,mCAAmC;EACnC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;EACtC,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;wCAEwC;AACxC;EACE,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;EAChC,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,6BAA6B,UAAU,EAAE;AACzC,6BAA6B,UAAU,EAAE;;AAEzC;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;;wCAEwC;AACxC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB,aAAa,EAAE;EAC/B,gBAAgB,WAAW,EAAE,YAAY,EAAE;EAC3C,oBAAoB,iBAAiB,EAAE;EACvC,cAAc,eAAe,EAAE;AACjC;;AAEA;;;wCAGwC;AACxC;;;qBAGqB,sCAAsC,EAAE;;AAE7D;EACE,iBAAiB;EACjB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;EACtC,6DAA6D;AAC/D;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');\n\n/* ======================================\n   DESIGN TOKENS\n====================================== */\n:root {\n  --brand:          #1565C0;\n  --brand-mid:      #1976D2;\n  --brand-light:    #42A5F5;\n  --brand-soft:     #E8F1FB;\n  --brand-glow:     rgba(21, 101, 192, 0.18);\n  --brand-glow-md:  rgba(21, 101, 192, 0.30);\n  --surface:        #ffffff;\n  --surface-2:      #F5F7FA;\n  --page-bg:        #F0F2F5;\n  --border:         #DCE8F8;\n  --border-strong:  #BBCFF5;\n  --text-primary:   #0C1A2E;\n  --text-secondary: #334D6E;\n  --text-muted:     #7090B0;\n  --font:           'Plus Jakarta Sans', sans-serif;\n  --ease:           cubic-bezier(0.16, 1, 0.3, 1);\n  --radius-sm:      8px;\n  --radius-md:      14px;\n  --radius-lg:      20px;\n  --radius-xl:      24px;\n  --shadow-sm:      0 1px 4px rgba(0,0,0,0.06), 0 4px 12px rgba(21,101,192,0.06);\n  --shadow-md:      0 4px 20px rgba(0,0,0,0.08), 0 12px 36px rgba(21,101,192,0.10);\n  --shadow-avatar:  0 4px 18px rgba(0,0,0,0.18);\n  --gpu-accelerate: translateZ(0);\n}\n\n* { box-sizing: border-box; margin: 0; padding: 0; }\n\nbody {\n  font-family: var(--font);\n  background-color: var(--page-bg);\n}\n\n/* ======================================\n   PAGE WRAPPER\n====================================== */\n.store-page-wrapper {\n  width: 100%;\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 80px 16px 40px; /* top padding for fixed Header */\n  font-family: var(--font);\n}\n\n/* ======================================\n   PROFILE CARD\n====================================== */\n.store-profile-card {\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-xl);\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  position: relative;\n  will-change: transform;\n  transform: var(--gpu-accelerate);\n  /* Top accent line */\n  --accent-h: 4px;\n}\n\n.store-profile-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: var(--accent-h);\n  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, #00BCD4 100%);\n  z-index: 2;\n  border-radius: var(--radius-xl) var(--radius-xl) 0 0;\n}\n\n/* ======================================\n   BANNER\n====================================== */\n.store-banner {\n  height: 200px;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: #C8D8ED;\n  position: relative;\n}\n\n/* Gradient overlay always on so text is readable if banner is bright */\n.store-banner::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom, transparent 50%, rgba(12,26,46,0.18) 100%);\n}\n\n.store-banner-gradient {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, #1565C0 0%, #42A5F5 50%, #00BCD4 100%);\n  opacity: 0.85;\n}\n\n/* ======================================\n   PROFILE BODY\n====================================== */\n.store-profile-body {\n  padding: 0 20px 20px;\n}\n\n/* ── Avatar + follow row ── */\n.store-avatar-row {\n  display: flex;\n  align-items: flex-end;\n  margin-top: -44px; /* pull avatar up over banner */\n  margin-bottom: 10px;\n  position: relative;\n  z-index: 3;\n}\n\n.store-avatar-wrap {\n  flex-shrink: 0;\n}\n\n.store-avatar {\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 4px solid var(--surface);\n  box-shadow: var(--shadow-avatar);\n  display: block;\n  background: var(--surface-2);\n  will-change: transform;\n  transform: var(--gpu-accelerate);\n  image-rendering: -webkit-optimize-contrast;\n}\n\n/* ── Follow button ── */\n.store-follow-btn {\n  padding: 9px 22px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: #fff;\n  border: none;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: 0 2px 10px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease), background 0.2s;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.store-follow-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 18px var(--brand-glow-md);\n}\n\n.store-follow-btn.following {\n  background: var(--surface-2);\n  color: var(--brand);\n  border: 1.5px solid var(--brand);\n  box-shadow: none;\n}\n\n.store-follow-btn.following:hover {\n  background: var(--brand-soft);\n  transform: translateY(-1px);\n}\n\n/* ── Name + description ── */\n/* Name + follow on same row */\n.store-name-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 4px;\n}\n\n.store-name-block {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n}\n\n.store-name {\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.4px;\n  line-height: 1.2;\n}\n\n.store-desc {\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--text-muted);\n  line-height: 1.55;\n}\n\n/* ======================================\n   NAVIGATION TABS\n====================================== */\n.store-tabs {\n  display: flex;\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  background: var(--surface);\n}\n\n.store-tab-btn {\n  flex: 1;\n  padding: 14px 12px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-muted);\n  border-bottom: 2.5px solid transparent;\n  transition: color 0.18s, border-color 0.18s, background 0.18s;\n  letter-spacing: 0.1px;\n}\n\n.store-tab-btn:hover {\n  color: var(--brand);\n  background: var(--brand-soft);\n}\n\n.store-tab-btn.active {\n  color: var(--brand);\n  border-bottom-color: var(--brand);\n  font-weight: 700;\n  background: transparent;\n}\n\n/* ======================================\n   TAB CONTENT\n====================================== */\n.store-tab-content {\n  padding: 4px 0 0;\n}\n\n/* ======================================\n   LOADING SKELETONS\n====================================== */\n.store-banner-skeleton {\n  height: 200px;\n  background: linear-gradient(90deg, #e0eaf6 25%, #f0f4fb 50%, #e0eaf6 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.4s infinite;\n}\n\n.store-avatar-skeleton {\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n  background: linear-gradient(90deg, #e0eaf6 25%, #f0f4fb 50%, #e0eaf6 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.4s infinite;\n  margin-top: -44px;\n  border: 4px solid var(--surface);\n}\n\n.store-skeleton-line {\n  height: 14px;\n  border-radius: 7px;\n  background: linear-gradient(90deg, #e0eaf6 25%, #f0f4fb 50%, #e0eaf6 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.4s infinite;\n  margin-top: 12px;\n}\n\n.store-skeleton-line.wide  { width: 55%; }\n.store-skeleton-line.narrow{ width: 35%; }\n\n@keyframes shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n@media (min-width: 769px) {\n  .store-page-wrapper {\n    padding-top: 100px;\n  }\n\n  .store-banner {\n    height: 240px;\n  }\n\n  .store-avatar {\n    width: 110px;\n    height: 110px;\n  }\n\n  .store-avatar-row {\n    margin-top: -55px;\n  }\n\n  .store-name {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  .store-page-wrapper {\n    padding: 72px 0 24px;\n  }\n\n  .store-profile-card {\n    border-radius: 0;\n    border-left: none;\n    border-right: none;\n  }\n\n  .store-banner {\n    height: 160px;\n  }\n\n  .store-profile-body {\n    padding: 0 14px 16px;\n  }\n\n  .store-avatar {\n    width: 76px;\n    height: 76px;\n  }\n\n  .store-avatar-row {\n    margin-top: -38px;\n  }\n\n  .store-follow-btn {\n    padding: 8px 18px;\n    font-size: 12.5px;\n  }\n\n  .store-name {\n    font-size: 19px;\n  }\n\n  .store-desc {\n    font-size: 13px;\n  }\n\n  .store-tab-btn {\n    font-size: 13px;\n    padding: 12px 8px;\n  }\n}\n\n@media (max-width: 360px) {\n  .store-banner { height: 140px; }\n  .store-avatar { width: 68px; height: 68px; }\n  .store-avatar-row { margin-top: -34px; }\n  .store-name { font-size: 17px; }\n}\n\n/* ======================================\n   KEPT — old classes used by child pages\n   (About, Posts, EditPosts, etc.)\n====================================== */\n.profile_container,\n.app-container,\n.store_container,\n.store-rec-pro-div { /* legacy wrappers — now passthrough */ }\n\n.follow-btn {\n  padding: 9px 22px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: 0 2px 10px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n}\n\n.follow-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 18px var(--brand-glow-md);\n}\n\n.navigation-tabs {\n  display: flex;\n  background-color: var(--surface);\n  border-bottom: 1px solid var(--border);\n}\n\n.navigation-tabs button {\n  padding: 13px 20px;\n  flex: 1;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-muted);\n  border-bottom: 2.5px solid transparent;\n  transition: color 0.18s, border-color 0.18s, background 0.18s;\n}\n\n.navigation-tabs button.active-tab {\n  border-bottom: 2.5px solid var(--brand);\n  color: var(--brand);\n  font-weight: 700;\n}\n\n.navigation-tabs button:hover {\n  color: var(--brand);\n  background-color: var(--brand-soft);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
